import React from 'react';
import {SessionManager} from '../../../utilities/session-management/session-manager';
import i18n from '../../../utilities/i18n';
import {env_vars} from '../../../utilities/load-env';

export const LogoutButton = () => {
    const handleLogout = () => {
        SessionManager.endSession();
        window.location.replace(env_vars.OIDC_POST_LOGOUT_REDIRECT_URI);
    };

    return (
        <button className='logout-btn' onClick={handleLogout}>
            {i18n.t('felles:logout')}
        </button>
    );
};
